module.exports = __webpack_public_path__ + "static/dev_66-c82c338a454192dad4c1a2b7f729e740.png";